import {useState} from 'react'
import {doc, writeBatch} from 'firebase/firestore'
import {useAuth} from '../../../../modules/auth'
import db, {storage} from '../../../../../services/firebase'
import {deleteObject, listAll, ref} from 'firebase/storage'
import ConfirmationModal from '../../../../components/ConfirmationModal'
import { showErrorToast, showSuccessToast } from 'app/components/ShowToast'
import Button from 'app/components/Button'

const DataRoomGrouping = ({selectedItems, currentAuditContext}) => {
  const {currentUser} = useAuth()
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteItems = async () => {
    try {
      setIsDeleting(true)
      const batch = writeBatch(db)
      const storageDeletePromises = []

      for (const item of selectedItems) {
        if (item.is_folder) {
          const tenantId = currentUser?.tenantId || ''
          const folderRef = ref(storage, `/tenants/${tenantId}/dataroom/${item.folder_name}`)

          const folderItems = await listAll(folderRef)
          folderItems.items.forEach(async (file) => {
            await deleteObject(file)
          })

          const folderDocRef = doc(db, 'tenants', currentUser?.tenantId!, 'dataroom', item.id)
          batch.delete(folderDocRef)
        } else {
          const fileDocRef = doc(db, 'tenants', currentUser?.tenantId!, 'dataroom', item.id)
          batch.delete(fileDocRef)
        }
      }

      await Promise.all([batch.commit(), Promise.all(storageDeletePromises)])
      showSuccessToast({message: 'All selected items have been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the selected items.'})
    } finally {
      setIsDeleting(false)
      setIsDeleteModalOpen(false)
    }
  }

  return (
    <>
      <div className='d-flex justify-content-end align-items-center'>
        {selectedItems.length > 0 ? (
          <div className=' pe-4 text-center' style={{color: '#A1A5B7'}}>
            <span>
              <p className='pt-4'>{selectedItems.length} Selected</p>
            </span>
          </div>
        ) : null}

        <div style={{display: 'flex', alignItems: 'center'}}>
          <Button
            onClick={() => setIsDeleteModalOpen(true)}
            btnType='destructive'
            className='ms-2'
            disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
          >
            Delete Selected
          </Button>
        </div>
      </div>

      {isDeleteModalOpen && (
        <ConfirmationModal
          isModalOpen={isDeleteModalOpen}
          hideModal={() => setIsDeleteModalOpen(false)}
          confirmBtnClickHandler={handleDeleteItems}
          toDeleteItemTitle={`${selectedItems.length} selected items`}
          isLoading={isDeleting}
          title="Remove Selected Items"
          message={`Are you sure you want to remove all selected items from the dataroom? This action cannot be undone.`}
          type="delete"
          confirmButtonText="Remove All"
        />
      )}
    </>
  )
}

export {DataRoomGrouping}